<template>
  <div class="filter-subway">
    <InputFilter
      :value="getSubwayStations"
      :placeholder="$t('placeholder.subway')"
      :is-disable="isInputActive"
      :clear-input="clearInput"
      :default-store-value="[]"
      :is-readonly-now="show"
      action-name="search/SET_SUBWAY"
      @clicked="handleClick"
    />
    <el-dialog
      class="filter-modal-wrapper"
      :visible.sync="show"
      width="300px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :center="true"
      :lock-scroll="true"
      :show-close="false"
    >
      <ModalSubway @clicked="chooseSubway" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputFilter from '@/components/Common/InputFilter'
import ModalSubway from '@/components/Search/Modals/Subway'

export default {
  name: 'Subway',
  components: {
    ModalSubway,
    InputFilter
  },
  data() {
    return {
      show: false,
      input: ''
    }
  },
  computed: {
    ...mapGetters({
      searchSubway: 'search/searchSubway',
      commonSubway: 'search/getCommonSubwayList',
      searchDistricts: 'search/searchDistrict',
      searchMicrodistricts: 'search/searchMicroDistrict',
      subwayLines: 'search/getSubwayMap'
    }),
    getSubwayStations() {
      return this.searchSubway ? this.getSubwayString() : null
    },
    isInputActive() {
      return !!(
        this.searchDistricts.length ||
        this.searchMicrodistricts.length ||
        !this.subwayLines ||
        !Object.keys(this.commonSubway).length
      )
    }
  },
  watch: {
    commonSubway: {
      immediate: true,
      handler(val) {}
    }
  },
  methods: {
    ...mapActions({
      resetSubway: 'search/SET_SUBWAY'
    }),
    chooseSubway() {
      this.show = false
      this.value = this.searchSubway.join(', ')
    },
    handleClick() {
      this.show = true
    },
    clearInput() {
      this.resetSubway([])
    },
    getSubwayString() {
      return this.searchSubway
        ? this.searchSubway
            .map((item) => {
              return this.commonSubway[item]?.title
            })
            .join(', ')
        : null
    }
  }
}
</script>

<style scoped></style>
